module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-dialog', {
    attrs: {
      "show": _vm.show,
      "title": _vm.title,
      "instructions": _vm.instructions,
      "dialogInputs": _vm.dialogInputs
    },
    on: {
      "click": _vm.close,
      "onClose": _vm.close,
      "onSubmit": function($event) {
        _vm.submit()
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cfad845","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/baseDialog.vue
// module id = 449
// module chunks = 1